@if (show) {
  <div [className]="'mmodal'">
    <div class="mmodal-body">
      <div>
        <button  class="closeXBtn" type="submit" (click)='close()' ></button>
        <br/><br/>
        <span class="usa-modal__heading margin-left-4" id="modal-1-heading">
          {{msg}}
        </span>
      </div>
      <br/>
    </div>
  </div>
}
@if (show) {
  <div class="mmodal-background"></div>
}

